<script lang="ts">
  import type {
    IFormImageChoiceNode,
    PartialNode,
  } from "@shared/common/node/type";
  import { generateFormDataName } from "@shared/common/utils/form";
  import { onMount } from "svelte";
  import detectReaction from "../../actions/detect-reaction";
  import {
    getCurrentDocumentNode,
    getFormContext,
    getOrInitCheckboxItem,
    getStore,
  } from "../../context";
  import FormImageChoiceOption from "./form/form-image-choice-option.svelte";
  import FormLabel from "./form/form-label.svelte";

  const { reactionEventListener } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormImageChoiceNode>;

  const { checkboxMap, width } = getFormContext();

  $: name = generateFormDataName(node);

  let flexBasis = "50%";

  $: {
    if ($width < 480) {
      flexBasis = "50%";
    } else if ($width < 700) {
      flexBasis = "33.33%";
    } else {
      flexBasis = "25%";
    }
  }

  onMount(() => {
    if (node.choiceType === "CHECKBOX") {
      const item = getOrInitCheckboxItem(checkboxMap, name);
      item.required = node.required || false;
      item.max = node.range?.type === "RANGE" ? node.range.max : undefined;
    }
  });
</script>

<div
  use:detectReaction={{
    node,
    documentNode,
    onAction: reactionEventListener,
  }}
  style={`--cb-form-image-choice-flex-basis: ${flexBasis}`}
>
  <FormLabel label={node.label} required={node.required} />
  {#if node.choiceType === "CHECKBOX" && node.range?.type === "RANGE" && typeof node.range.max === "number"}
    <span class="form-choice-limit">
      최대 {node.range.max}개 선택
    </span>
  {/if}

  <div class="form-image-option-container">
    {#each node.items || [] as item, index}
      <FormImageChoiceOption
        {name}
        {index}
        id={item.id}
        type={node.choiceType}
        url={item.url}
        required={node.required}
      />
    {/each}
  </div>
</div>

<style>
  .form-image-option-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(var(--cb-form-font-size) * 0.5);
  }

  .form-choice-limit {
    display: block;
    text-align: left;
    color: rgba(var(--cb-form-font-color), 0.7);
    font-size: var(--cb-text-base);
    line-height: var(--cb-line-height-base);
  }
</style>
